import { createSelector } from 'reselect';

const userProfilePageSelector = state => state?.userProfilePageReducer ?? {};
const userTicketsSelector = state => userProfilePageSelector(state)?.tickets || [];
export const userSelectedTicketsIdsSelector = state => userProfilePageSelector(state)?.selectedTicketsIds || [];

export const personIdByTicketSelector = createSelector(
    userTicketsSelector,
    userSelectedTicketsIdsSelector,
    (tickets, selectedTicketsIds, ) => ({
        personId: tickets[0]?.personId,
        selectedTicketsIds
    })
);
